import { InventoryFormikValuesDto } from "../InventoryFormikValuesDto";
import { QuantityGetDto, toLocalEquivalentUtcDate } from "svila-common";

export const quantityGetDtoToFormik = (item: QuantityGetDto, emptyQuantities: boolean): InventoryFormikValuesDto => {
  const formik: InventoryFormikValuesDto = {
    singleCuUnits: emptyQuantities ? '' : nullableNumberToString(item.singleCuUnits),
    singleDpUnits: emptyQuantities ? '' : nullableNumberToString(item.singleDpUnits),
    fullDuUnits: emptyQuantities ? '' : nullableNumberToString(item.fullDuUnits),
    accountedPrice: nullableNumberToString(item.accountedPrice),
    accountedValue: nullableNumberToString(item.accountedValue),
    expirationDate: toLocalEquivalentUtcDate(item.expirationDate) ?? '',
    productionDate: toLocalEquivalentUtcDate(item.productionDate) ?? '',
    movementType: item.movementType,
    supplierId: item?.supplier?.id ?? '',
    manufacturerId: item?.manufacturer?.id ?? '',
    sellOrderId: item?.sellOrder?.id ?? '',
    purchaseOrderId: item?.purchaseOrder?.id ?? '',
    status: item.status,
    condition: item.condition,
    lot: item.lot ?? '',
    chamberNumber: item?.warehouseLocation?.warehouseChamber?.number
      ? item?.warehouseLocation?.warehouseChamber?.number.toString()
      : '',
    column: item?.warehouseLocation?.column ? item?.warehouseLocation?.column.toString() : '',
    letter: item?.warehouseLocation?.letter ? item?.warehouseLocation?.letter.toString() : '',
    level: item?.warehouseLocation?.level ? item?.warehouseLocation?.level.toString() : '',
    isInvoiced: item?.isInvoiced,
    isRemoved: item.isRemoved,
    notes: item.notes,
    transactionDateTime: toLocalEquivalentUtcDate(item.transactionDateTime) ?? '',
    warehouseOwnerId: item?.warehouseOwner?.id,
    warehouseId: item?.warehouse?.id
  };
  return formik;
};

const nullableNumberToString = (nullableNumber: number | null): string => {
  if (nullableNumber) {
    return nullableNumber.toString();
  }
  return '';
};